function normalizeProviderName(value: any): string {
  return String(value || '').toLowerCase();
}

export function normalizeMembershipType(value: any): string {
  return String(value || '').toLowerCase().replace(/[\s_-]/g, '');
}

export function isIndependentMembership(membership: any): boolean {
  if (!membership) return false;
  const provider = normalizeProviderName(membership.provider || membership.organization);
  return provider === 'independent';
}

export function isIndependentNonOwner(membership: any): boolean {
  if (!membership) return false;
  return isIndependentMembership(membership) && normalizeMembershipType(membership.type) === 'nonowner';
}

export function isIndependentAircraftOwner(membership: any): boolean {
  if (!membership) return false;
  return isIndependentMembership(membership) && normalizeMembershipType(membership.type) === 'aircraftowner';
}

export function isIndependentNoAircraft(memberships: any[] | undefined): boolean {
  if (!Array.isArray(memberships) || memberships.length === 0) return false;

  const allIndependent = memberships.every((m: any) => isIndependentMembership(m));
  if (!allIndependent) return false;

  const anyAircraft = memberships.some((m: any) => !!m?.defaultAircraft);
  if (anyAircraft) return false;

  return memberships.some((m: any) => isIndependentNonOwner(m));
}
